module.exports = __webpack_public_path__ + "static/media/microcontroller.228ca802.jpg";